import React, { Suspense, useContext } from 'react'
import CONFIGS from 'build/Config'
import { LoaderContext } from 'contexts/loader-context'

const Header = () => {
  const { head } = useContext(LoaderContext)

  const version = CONFIGS.versionPh || 'v1'

  const HeaderVersion = React.lazy(() => import(`components/header/${version}`))

  if (!head) {
    return null
  }

  return (
    <Suspense fallback={<></>}>
      <HeaderVersion />
    </Suspense>
  )
}

export default Header
